import { c as _c } from "react/compiler-runtime";
import Section from "@components/Section";
import { getSerifClass, isInverted } from "@components/utilities";
import { ComponentSectionsAccordionV2 } from "@lib/generated/graphql";
import Accordion from "@modules/homepage/components/Accordion";
import clsx from "clsx";
import { FC } from "react";
const AnimatedAccordion: FC<{
  data: ComponentSectionsAccordionV2;
}> = t0 => {
  const $ = _c(18);
  const {
    data
  } = t0;
  if (!data.items) {
    return null;
  }
  const {
    title,
    subTitle,
    autoOpenInterval,
    autoOpen,
    background
  } = data;
  let t1;
  if ($[0] !== background) {
    t1 = isInverted(background);
    $[0] = background;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const inverted = t1;
  let t2;
  if ($[2] !== background) {
    t2 = getSerifClass(background);
    $[2] = background;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const serifClass = t2;
  const t3 = !background?.variant;
  const t4 = background?.variant;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = clsx("px-s m:px-3xl", {
      "my-l m:my-[160px]": t3,
      "pb-m pt-3m m:py-3xl my-2s m:my-3s": t4
    });
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = autoOpen ? autoOpenInterval : 0;
  let t7;
  if ($[7] !== data.items || $[8] !== inverted || $[9] !== serifClass || $[10] !== subTitle || $[11] !== t6 || $[12] !== title) {
    t7 = <Accordion items={data.items} serifClass={serifClass} inverted={inverted} autoOpenInterval={t6} title={title} subtitle={subTitle} />;
    $[7] = data.items;
    $[8] = inverted;
    $[9] = serifClass;
    $[10] = subTitle;
    $[11] = t6;
    $[12] = title;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== data || $[15] !== t5 || $[16] !== t7) {
    t8 = <Section section={data} className={t5}>{t7}</Section>;
    $[14] = data;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default AnimatedAccordion;